import { apiSlice } from "../api/apiSlice";

export const teamsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addTeam: builder.mutation({
            query: (data) => ({
                url: "/teams",
                method: "POST",
                body: data,
            }),
         
        }),
        getTeams: (builder).query({
            query: (email) => `/teams?userEmail_like=${email}`,
        }),
        
    }),
});

export const {useAddTeamMutation, useGetTeamsQuery } = teamsApi;